import { Box, Icon, IconButton, Paragraph } from '@alto-avios/alto-ui'
import style from './RefundabilityButton.module.scss'

export const RefundabilityButton = ({
  label,
  buttonLabel,
  onClick,
  hideLeftIcon = false,
}: {
  label: string
  buttonLabel: string
  onClick: () => void
  hideLeftIcon?: boolean
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      padding={null}
      borderWidth="none"
      gap="2xs"
      className={style.optionInfoBox}
    >
      {!hideLeftIcon && <Icon iconName="check" iconSize="1x" iconPrefix="far" />}
      <Box padding={null} className={style.inlineText}>
        <Paragraph size="sm">{label}</Paragraph>
      </Box>
      <Box>
        <IconButton
          aria-label={buttonLabel}
          emphasis="quaternary"
          iconProps={{
            iconName: 'circle-info',
            iconPrefix: 'far',
            iconSize: '1x',
            border: false,
          }}
          focusStyle="white"
          onClick={onClick}
          size="sm"
          tooltipLabel={buttonLabel}
        />
      </Box>
    </Box>
  )
}
